$(function () {
    let App = window.App;
    App.productVariations = {};
    App.productVariations.ajax = false;

    App.productVariations.openModal = function ($this) {
        let $modal = $('#productVariationsModal');

        let prevRequest = App.productVariations.ajax;

        App.productVariations.ajax = $.ajax({
            type: 'POST',
            url: $this.data('action'),
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }

                $this.addClass('pending');
            },
            success: function (response) {
                if (response.hasOwnProperty('view')) {
                    $modal.find('.modal-body').html(response.view);
                    window.App.initTooltips();
                    App.modal.open($modal);
                }
            },
            complete: function () {
                App.productVariations.ajax = false;
                $this.removeClass('pending');
            },
        });
    }

    App.productVariations.chooseVariationProduct = function ($this, url) {
        let $modal = $this.closest('.modal');
        let $modalBody = $modal.find('.modal-body');

        let prevRequest = App.productVariations.ajax;

        App.productVariations.ajax = $.ajax({
            type: 'POST',
            url: $this.data('action'),
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }

                $modalBody.addClass('pending');
            },
            success: function (response) {
                if (response.hasOwnProperty('view')) {
                    $modalBody.html(response.view);
                    window.App.initTooltips();
                    $modal.find('#chooseProductBtn').attr('href', url);
                }
            },
            complete: function () {
                App.productVariations.ajax = false;
                $modalBody.removeClass('pending');
            },
        });
    }
});